import React, { useEffect, useRef } from 'react';

import { StyleSheet, useWindowDimensions } from 'react-native';

import { Box } from 'components/ui';
import { routes } from 'navigation/routing';
import { t } from 'state/intl/translations';
import { useIsLoyaltyEnabled } from 'state/loyalty/hooks/use-is-loyalty-enabled';
import { spacing } from 'styles/constants';
import { breakpoints } from 'styles/constants/breakpoints';
import { isWeb } from 'utils/environment';

import SignUpHeadlineText from './sign-up-headline-text';
import {
  LogoLink,
  RewardsLinkStyled,
  StyledBKLogo,
  StyledRewardsLogo,
} from './sign-up-headline.styled';

const SignUpHeadline = ({ disableLink = false }: { disableLink?: boolean }) => {
  const loyaltyEnabled = useIsLoyaltyEnabled();
  const { width } = useWindowDimensions();
  const isSmallOrLarger = width >= breakpoints.sm;

  const title = t('bk_logo_title');
  const logoLinkPath = disableLink ? null : { to: routes.base };

  const rewardsLink = (
    <RewardsLinkStyled {...(!disableLink && { linkPath: routes.bkRewards })}>
      {t('royalPerks')}
    </RewardsLinkStyled>
  );

  const signUpTextRef = useRef(null);

  useEffect(() => {
    if (signUpTextRef.current && isWeb) {
      (signUpTextRef.current as HTMLElement).focus();
    }
  }, []);

  return (
    <Box style={isSmallOrLarger && styles.containerSmall}>
      {loyaltyEnabled ? (
        <>
          <LogoLink {...logoLinkPath} focusable={false} accessible={false}>
            <StyledRewardsLogo testID="sign-up-loyalty-logo" />
          </LogoLink>
          <Box focusable={false} ref={signUpTextRef}>
            <SignUpHeadlineText rewardsLink={rewardsLink} />
          </Box>
        </>
      ) : (
        <LogoLink {...logoLinkPath}>
          <StyledBKLogo variant="BkLogoPrimary" title={title} testID="brand-logo" />
        </LogoLink>
      )}
    </Box>
  );
};

export default SignUpHeadline;

const styles = StyleSheet.create({
  containerSmall: {
    paddingTop: spacing.$6,
  },
});
